var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "data-view-container",
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('div', {
    staticClass: "data-view-label"
  }, [_vm._v(_vm._s(_vm.label) + ":")]), _c('div', {
    staticClass: "data-view-description"
  }, [_vm._v(_vm._s(_vm.displayDescription))]), _c('div', {
    staticClass: "data-view-icon",
    class: _vm.iconClass
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }